import script from "./AtendimentoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AtendimentoPage.vue?vue&type=script&setup=true&lang=js"

import "./AtendimentoPage.vue?vue&type=style&index=0&id=16bd881c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16bd881c"]])

export default __exports__